import React, { useEffect, useState } from "react";

//Local components
import DataLoader from "../Components/basics/DataLoader";
import ErrorBox from "../Components/ErrorBox";
import SupplierRow from "../Components/suppliers-page/SupplierRow";
import SetSupplierDrawer from "../Components/drawers/SetSupplierDrawer";

//UI material
import {
  Button,
  Card,
  Divider,
  Grid,
  Stack,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TablePagination,
  TableRow,
  Typography,
} from "@mui/material";

//Material Icons
import { Add, ArrowBackIos } from "@mui/icons-material";

//Helpers
import { fetchWithTokenJSONPost } from "../Helpers/network";

export default function Suppliers() {
  //State for open/close drawer for set product
  const [openDrawer, setOpenDrawer] = useState(false);
  //State for select page
  const [page, setPage] = useState(0);
  //State for manage rows per page
  const [rowsPerPage, setRowsPerPage] = useState(10);
  //State for setting loader for suppliers data
  const [dataLoader, setDataLoader] = useState(true);
  //State for setting error when could not get suppliers data
  const [dataError, setDataError] = useState(false);
  //State for suppliers list data
  const [suppliersList, setSuppliersList] = useState([]);

  //The useEffect checks for token validation
  useEffect(() => {
    getSuppliersList();
  }, []);

  // ==========>Component Functions<==========
  //Function to manage page selection
  const handleChangePage = (_event, newPage) => {
    setPage(newPage);
  };
  //Function to control rows per page options
  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  //Function to get items list
  const getSuppliersList = async () => {
    try {
      const requestResponse = await fetchWithTokenJSONPost(
        `/inventory/get-suppliers`,
        {
          howMany: 2500,
        }
      );
      const jsonResponse = await requestResponse.json();
      if (requestResponse.status === 200) {
        setSuppliersList(jsonResponse.data);
      } else {
        if (requestResponse.status === 401) {
          window.location.href = "/";
        }
      }
    } catch (error) {
      setDataError(false);
    }
    setDataLoader(false);
  };

  // ==========>Component<==========
  if (dataLoader) {
    return <DataLoader />;
  }

  return dataError ? (
    <ErrorBox />
  ) : (
    <Grid container spacing={1}>
      <SetSupplierDrawer
        open={openDrawer}
        setOpen={setOpenDrawer}
        getData={getSuppliersList}
        isNewSupplier={true}
      />
      <Grid item xs={12}>
        <Stack
          direction="row"
          alignItems="center"
          justifyContent="space-between"
          spacing={1}
        >
          <Button
            startIcon={<ArrowBackIos />}
            color="secondary"
            sx={{ color: "white" }}
            variant="contained"
            size="small"
            onClick={() => {
              window.history.back();
            }}
          >
            Volver
          </Button>
          <Button
            variant="contained"
            color="secondary"
            size="small"
            sx={{ color: "white" }}
            endIcon={<Add />}
            onClick={() => {
              setOpenDrawer(true);
            }}
          >
            nuevo proveedor
          </Button>
        </Stack>
      </Grid>
      <Grid item xs={12}>
        <Card raised>
          <Grid container>
            <Grid item xs={12} sx={{ p: 2 }}>
              <Typography variant="h6" fontWeight="bold">
                Lista de proveedores
              </Typography>
            </Grid>
            <Grid item xs={12} sx={{ p: 2 }}>
              <Stack
                direction="row"
                alignItems="center"
                justifyContent="flex-start"
                spacing={1}
              >
                <Typography variant="h6" fontWeight="bold">
                  {suppliersList.length}
                </Typography>
                <Typography variant="h7">proveedores registrados</Typography>
              </Stack>
            </Grid>
            <Grid item xs={12}>
              <Divider />
            </Grid>
            <Grid item xs={12}>
              <TableContainer>
                <Table aria-label="suppliers-table">
                  <TableHead>
                    <TableRow>
                      <TableCell align="center">
                        <Typography variant="body2" fontWeight="bold">
                          ID
                        </Typography>
                      </TableCell>
                      <TableCell align="center">
                        <Typography variant="body2" fontWeight="bold">
                          Nombre proveedor
                        </Typography>
                      </TableCell>
                      <TableCell align="center">
                        <Typography variant="body2" fontWeight="bold">
                          Dirección
                        </Typography>
                      </TableCell>
                      <TableCell align="center">
                        <Typography variant="body2" fontWeight="bold">
                          Correo electrónico
                        </Typography>
                      </TableCell>
                      <TableCell align="center">
                        <Typography variant="body2" fontWeight="bold">
                          Número telefónico
                        </Typography>
                      </TableCell>
                      <TableCell align="center">
                        <Typography variant="body2" fontWeight="bold">
                          Acciones
                        </Typography>
                      </TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {suppliersList
                      .sort((a, b) => {
                        if (a.name < b.name) return -1;
                        if (a.name > b.name) return 1;
                        return 0;
                      })
                      .map((s) => (
                        <SupplierRow
                          key={`${s.id}-${s.createdAt}`}
                          supplier={s}
                        />
                      ))
                      .slice(
                        page * rowsPerPage,
                        page * rowsPerPage + rowsPerPage
                      )}
                  </TableBody>
                </Table>
              </TableContainer>
              <TablePagination
                component="div"
                count={suppliersList.length}
                page={page}
                onPageChange={handleChangePage}
                rowsPerPage={rowsPerPage}
                labelRowsPerPage="Filas"
                onRowsPerPageChange={handleChangeRowsPerPage}
              />
            </Grid>
          </Grid>
        </Card>
      </Grid>
    </Grid>
  );
}
